const latestMatches = (matches, teamId, howMany) => {
  let result = []
  matches.forEach((match) => {
    if (match.homeId === teamId || match.awayId === teamId) result.push(match)
  })
  return result.slice(0, howMany)
}
export default latestMatches
